import { CALENDAR_MAX_WIDTH } from "@components/calendar";
import { StyledFieldsWrapper } from "@components/inputs/field/FieldsWrapper.styles";
import styled from "styled-components";

import { T_HEADER_small, T_TITLE_4, T_TITLE_4_NORMAL } from "../../../global.style";

const DAY_EDIT_MIN_WIDTH = 500; // https://solitea-cz.atlassian.net/browse/DEV-44765
const MAX_GAP_BETWEEN_CALENDAR_AND_DAY_EDIT = 116; // https://app.zeplin.io/project/5db5a8ceedf4a42c0f42299d/screen/641ad47984b71e220f2603f6

export const DayEditWrapper = styled.div`
    min-width: ${DAY_EDIT_MIN_WIDTH}px;
    & > ${StyledFieldsWrapper} {
        margin-top: 30px;
    }
`;

export const CalendarWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 30px;
`;

export const CalendarGrid = styled.div`
    display: grid;
    grid-gap: 25px;
    grid-template-columns: repeat(7, 1fr);
    margin-bottom: 20px;
`;

export const DayLabel = styled.div`
    text-transform: uppercase;
    ${T_TITLE_4};
    text-align: center;
    margin-bottom: -12px;
`;

export const Day = styled.div`
    ${T_TITLE_4_NORMAL};
    text-align: center;
`;

export const AdditionalInfo = styled.div`
    ${T_TITLE_4_NORMAL};
    align-self: flex-start;
    margin-top: 10px;
`;

export const MonthYearLabel = styled.div`
    ${T_HEADER_small};
    text-transform: capitalize;
    margin-bottom: 24px;
`;

export const AttendanceCalendarWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    column-gap: 56px;
    row-gap: 17px;
    width: 100%;
    justify-content: space-between;
    max-width: ${CALENDAR_MAX_WIDTH + DAY_EDIT_MIN_WIDTH + MAX_GAP_BETWEEN_CALENDAR_AND_DAY_EDIT}px;
`;

export const MonthlyOverviewWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 29px;
    flex-grow: 1;
    min-width: ${DAY_EDIT_MIN_WIDTH}px;
    max-width: ${CALENDAR_MAX_WIDTH}px;
    margin-top: 17px;
`;

export const BalancingPeriodOverviewWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 29px;
    width: 100%;
    min-width: ${DAY_EDIT_MIN_WIDTH}px;
    max-width: ${CALENDAR_MAX_WIDTH}px;
    margin-top: 17px;
`;

export const MonthlyOverviewTitle = styled.div`
    ${T_TITLE_4};
    font-weight: bold;
    text-transform: uppercase;
    display: flex;
    align-items: center;

    &::after {
        content: " ";
        display: block;
        flex-grow: 1;
        height: 2px;
        margin-left: 10px;
        background-color: ${({ theme }) => theme.C_FIELD_section_line};
    }
`;

export const MonthlyOverviewColumns = styled.div`
    display: grid;
    grid-template-columns: repeat(2, max-content);
    justify-content: space-between;
    column-gap: 38px;
    row-gap: 17px;
    box-sizing: border-box;
    padding-right: 38px;
`;


export const UnevenWorkingPatternWrapper = styled.div`
    ${T_TITLE_4};
    font-weight: bold;
    text-transform: uppercase;
    align-self: flex-start;
    margin-bottom: 10px;
`;
